export default __webpack_public_path__ + "static/customer_details-abd68543df8b0a92a66a2b987d900aa6.png";